import { Stamp } from '@/components/UI/Stamp'
import { Typography } from '@/components/UI/Typography'
import { memo } from 'react'

type StampComponentsType = {
  query: number
  hasCount: number
  course: string | string[]
  img: string | null
  name: string
  spots: [
    {
      address: string
      id: number
      name: string
      zip: string
    },
  ]
  isRepeatStamp: boolean
  stampShape: 'circular' | 'square'
  onGroupModal: () => void
}

export const StampComponents = memo(
  ({ query: _query, hasCount, img, name, isRepeatStamp, stampShape, onGroupModal }: StampComponentsType) => {
    return (
      <>
        <button
          type="button"
          className="flex flex-col items-center justify-start w-full"
          onClick={() => {
            onGroupModal()
          }}
        >
          <Stamp
            type={img ? 'Get' : 'None'}
            src={img ?? undefined}
            size="Medium"
            shape={stampShape}
            count={isRepeatStamp ? hasCount : undefined}
          />

          {/* 単語境界で折り返し、空白を含まない長い名称のみ途中で切る（#3555）。
              break-all は英単語の途中でも無条件に改行してしまうため使わない */}
          <Typography variant="caption1" className="mt-1 [overflow-wrap:anywhere]">
            {name}
          </Typography>
        </button>
      </>
    )
  },
)
